import { Box } from '@mui/material';
import { designTokens } from '../../design-system';

/** 작성 및 조회 결재 흐름이 공유하는 순차 연결선과 병렬 분기선입니다. */
export function WorkflowApprovalConnector({ compact = false }: { compact?: boolean }) {
  return (
    <Box
      aria-hidden="true"
      data-testid="workflow-approval-connector"
      sx={{
        position: 'relative',
        flex: '0 0 auto',
        alignSelf: { xs: 'center', md: 'auto' },
        width: { xs: 32, md: compact ? 14 : 16 },
        height: { xs: 24, md: 32 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: { xs: 0, md: '50%' },
          left: { xs: '50%', md: 0 },
          width: { xs: 2, md: '100%' },
          height: { xs: '100%', md: 2 },
          bgcolor: designTokens.color.strongDivider,
          transform: { xs: 'translateX(-50%)', md: 'translateY(-50%)' },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          right: { xs: 'auto', md: 0 },
          bottom: { xs: 0, md: 'auto' },
          left: { xs: 'calc(50% - 3px)', md: 'auto' },
          top: { xs: 'auto', md: 'calc(50% - 3px)' },
          width: 6,
          height: 6,
          borderRight: `2px solid ${designTokens.color.strongDivider}`,
          borderBottom: `2px solid ${designTokens.color.strongDivider}`,
          transform: { xs: 'rotate(45deg)', md: 'rotate(-45deg)' },
        }}
      />
    </Box>
  );
}

export function WorkflowApprovalBranchRail({
  side,
  index,
  count,
  component = 'div',
}: {
  side: 'fork' | 'join';
  index: number;
  count: number;
  component?: 'div' | 'li';
}) {
  const first = index === 0;
  const last = index === count - 1;
  const railLeft = 14;
  return <Box
    component={component}
    aria-hidden="true"
    sx={{
      position: 'relative',
      gridColumn: side === 'fork' ? 1 : 3,
      gridRow: index + 1,
      minHeight: '100%',
    }}
  >
    <Box sx={{ position: 'absolute', top: '50%', left: side === 'fork' ? railLeft : 0, right: side === 'fork' ? 0 : 14, height: 2, bgcolor: designTokens.color.strongDivider, transform: 'translateY(-50%)' }} />
    <Box sx={{ position: 'absolute', top: first ? '50%' : -4, bottom: last ? '50%' : -4, left: railLeft, width: 2, bgcolor: designTokens.color.strongDivider, transform: 'translateX(-50%)' }} />
    <Box sx={{
      position: 'absolute',
      top: 'calc(50% - 3px)',
      left: side === 'fork' ? 'auto' : 8,
      right: side === 'fork' ? 1 : 'auto',
      width: 6,
      height: 6,
      borderRight: `2px solid ${designTokens.color.strongDivider}`,
      borderBottom: `2px solid ${designTokens.color.strongDivider}`,
      transform: 'rotate(-45deg)',
    }} />
  </Box>;
}
